import { reset } from 'redux-form'
import lodash from 'lodash';

import { extensionServices } from '../services';
import { extensionConstants } from '../constants';
import { loader, alert as customAlert } from 'helpers';
import i18n from 'i18n';

const defaultFailedText = 'api_messages.SOMETHING_WENT_WRONG';

export const extensionAction = {
   oauthInitiate,
   getMagentoToken,
   generateApiKey
};

function oauthInitiate(merchantId) {
    console.log("oauthInitiate")
    return dispatch => {
        extensionServices.oauthInitiate(merchantId)
         .then(
            response => {
               if (response.status) {
                  if (lodash.has(response, 'data')) {
                     //console.log(response.data.data);
                     dispatch(success(response.data));
                  }
               } else {
                  if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            // loader(dispatch, false)
         })
   };

   function success(data) {
    return { type: extensionConstants.GET_OAUTH_INITIATE_SUCCESS, data }
   }
   
}

function getMagentoToken(merchantId) {
    console.log("getMagentoToken")
    console.log("merchantId", merchantId)
    return dispatch => {
        extensionServices.getMagentoToken(merchantId)
         .then(
            response => {
               if (response.status) {
                  if (lodash.has(response, 'data')) {
                     // console.log("getMagentoToken" , response.data);
                     dispatch(success(response.data));
                  }
               } else {
                  if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            // loader(dispatch, false)
         })
   };

   function success(data) {
    return { type: extensionConstants.GET_MAGENTO_TOKEN_SUCCESS, data }
   }
   
}

function generateApiKey(merchantId, reqParams) {
   return dispatch => {
      extensionServices.generateApiKey(merchantId, reqParams)
      .then(
         response => {
            if (response.status) {
               if (lodash.has(response, 'data')) {
                  // console.log(response.data);
                  window.open(response.data.data.authUrl, '_blank');
                  dispatch(success(response.data));
               }
            } else {
               if(!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
            }
         },
         error => {
            customAlert(dispatch, 'error', i18n.t(defaultFailedText))
         }
      ).then(() => {
         // loader(dispatch, false)
      })
   };

   function success(data) {
      return { type: extensionConstants.GET_OAUTH_INITIATE_SUCCESS, data }
   }
   
}
